import { useSelector } from "react-redux";
export const metarMapSelector = (state) => state.weather.metars;
const metarEntrySelector = (state, station) => state.weather.metars[station];
export const useMetar = (station) => {
    const entry = useSelector((state) => metarEntrySelector(state, station));
    return { timeRecorded: entry?.timeMetarRecorded ?? 0, metar: entry?.metar ?? null };
};
export const useAltimeter = (station) => {
    const entry = useSelector((state) => metarEntrySelector(state, station));
    const altimeter = entry?.altimeter ? (entry.altimeter * 100).toFixed(0).padStart(4, "0") : null;
    return { timeRecorded: entry?.timeAltimeterRecorded ?? 0, altimeter };
};
export const altimeterAirportsSelector = (state) => state.weather.altimAirportList;
export const metarAirportsSelector = (state) => state.weather.metarAirportList;
//# sourceMappingURL=weatherHooks.js.map